import generateUtilityClass from '@mui/material/generateUtilityClass';
import generateUtilityClasses from '@mui/material/generateUtilityClasses';

interface LabelClasses {
  /** Styles applied to the root element. */
  root?: string;
  /** Styles applied to the root element if `variant="text"`. */
  text?: string;
  /** Styles applied to the root element if `variant="text"` and `color="primary"`. */
  textPrimary?: string;
  /** Styles applied to the root element if `variant="text"` and `color="secondary"`. */
  textSecondary?: string;
  /** Styles applied to the root element if `variant="text"` and `color="success"`. */
  textSuccess?: string;
  /** Styles applied to the root element if `variant="text"` and `color="error"`. */
  textError?: string;
  /** Styles applied to the root element if `variant="text"` and `color="info"`. */
  textInfo?: string;
  /** Styles applied to the root element if `variant="text"` and `color="warning"`. */
  textWarning?: string;
  /** Styles applied to the root element if `variant="text"` and `color="neutral"`. */
  textNeutral?: string;
  /** Styles applied to the root element if `variant="outlined"`. */
  outlined?: string;
  /** Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
  outlinedPrimary?: string;
  /** Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
  outlinedSecondary?: string;
  /** Styles applied to the root element if `variant="outlined"` and `color="success"`. */
  outlinedSuccess?: string;
  /** Styles applied to the root element if `variant="outlined"` and `color="error"`. */
  outlinedError?: string;
  /** Styles applied to the root element if `variant="outlined"` and `color="info"`. */
  outlinedInfo?: string;
  /** Styles applied to the root element if `variant="outlined"` and `color="warning"`. */
  outlinedWarning?: string;
  /** Styles applied to the root element if `variant="outlined"` and `color="neutral"`. */
  outlinedNeutral?: string;
  /** Styles applied to the root element if `variant="contained"`. */
  contained?: string;
  /** Styles applied to the root element if `variant="contained"` and `color="primary"`. */
  containedPrimary?: string;
  /** Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
  containedSecondary?: string;
  /** Styles applied to the root element if `variant="contained"` and `color="success"`. */
  containedSuccess?: string;
  /** Styles applied to the root element if `variant="contained"` and `color="info"`. */
  containedInfo?: string;
  /** Styles applied to the root element if `variant="contained"` and `color="error"`. */
  containedError?: string;
  /** Styles applied to the root element if `variant="contained"` and `color="warning"`. */
  containedWarning?: string;
  /** Styles applied to the root element if `variant="contained"` and `color="neutral"`. */
  containedNeutral?: string;
  /** Styles applied to the root element if `size="small"` and `variant="text"`. */
  textSizeSmall?: string;
  /** Styles applied to the root element if `size="medium"` and `variant="text"`. */
  textSizeMedium?: string;
  /** Styles applied to the root element if `size="small"` and `variant="outlined"`. */
  outlinedSizeSmall?: string;
  /** Styles applied to the root element if `size="medium"` and `variant="outlined"`. */
  outlinedSizeMedium?: string;
  /** Styles applied to the root element if `size="small"` and `variant="contained"`. */
  containedSizeSmall?: string;
  /** Styles applied to the root element if `size="medium"` and `variant="contained"`. */
  containedSizeMedium?: string;
  /** Styles applied to the root element if `size="small"`. */
  sizeSmall?: string;
  /** Styles applied to the root element if `size="medium"`. */
  sizeMedium?: string;
  /** Styles applied to the startIcon element if supplied. */
  startIcon?: string;
  /** Styles applied to the endIcon element if supplied. */
  endIcon?: string;
  /** Styles applied to the icon element if supplied and `size="small"`. */
  iconSizeSmall?: string;
  /** Styles applied to the icon element if supplied and `size="medium"`. */
  iconSizeMedium?: string;
}

function getLabelUtilityClass(slot: string) {
  return generateUtilityClass('Label', slot);
}

const labelClasses: LabelClasses = generateUtilityClasses('Label', [
  'root',
  'text',
  'textPrimary',
  'textSecondary',
  'textSuccess',
  'textError',
  'textInfo',
  'textWarning',
  'textNeutral',
  'outlined',
  'outlinedPrimary',
  'outlinedSecondary',
  'outlinedSuccess',
  'outlinedError',
  'outlinedInfo',
  'outlinedWarning',
  'outlinedNeutral',
  'contained',
  'containedPrimary',
  'containedSecondary',
  'containedSuccess',
  'containedInfo',
  'containedError',
  'containedWarning',
  'containedNeutral',
  'textSizeSmall',
  'textSizeMedium',
  'outlinedSizeSmall',
  'outlinedSizeMedium',
  'containedSizeSmall',
  'containedSizeMedium',
  'sizeSmall',
  'sizeMedium',
  'startIcon',
  'endIcon',
  'iconSizeSmall',
  'iconSizeMedium',
]);

type LabelClassKey = keyof LabelClasses;

export type { LabelClasses, LabelClassKey };
export { labelClasses, getLabelUtilityClass };
